var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancellation-survey-header"},[_c('h2',{staticClass:"cancellation-survey-header__headline container"},[_vm._v("\n    "+_vm._s(this.isLeavingMup ? _vm.$t("headlineMultiUserPlan") : _vm.$t("headline"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }